var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlot = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "plot_svg__b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#plot_svg__a",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  id: "plot_svg__a",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#plot_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M19.547 6.902 11.999 2l-.003.002V2L4.446 6.902l.725 1.115 1.325-.86V13.5h4.251v-4h2.5v4h4.249V7.156l1.326.861zM1.084 12.46l3.918-2.247v1.318l-2.935 1.684q-.077.044-.121.12-.045.077-.045.165t.045.165.12.12l8.938 5.127q.114.065.234.114.12.05.246.083.126.034.256.05.129.018.259.018t.26-.017q.129-.017.255-.05.126-.034.246-.084t.234-.114l8.937-5.126q.077-.044.121-.121.045-.076.045-.165 0-.088-.045-.165-.044-.076-.12-.12l-2.93-1.68v-1.318l3.912 2.243q.137.079.249.19.112.112.192.25.079.136.12.289t.041.311-.041.311-.12.29q-.08.137-.192.249t-.25.19l-9.422 5.405q-.17.097-.35.171-.181.075-.37.125t-.383.076q-.193.025-.389.025-.195 0-.39-.025-.193-.026-.382-.076t-.37-.125-.35-.171L1.084 14.54q-.137-.079-.249-.19-.112-.112-.192-.249-.079-.137-.12-.29t-.041-.31q0-.16.041-.312.041-.153.12-.29.08-.137.192-.248.112-.112.25-.19"
}))));
export default SvgPlot;